import { computed } from 'vue'
import { useSettingsStore } from '@/stores/settings'

/**
 * useCms Composable
 * 
 * Provides convenient access to CMS content throughout the application
 * Usage:
 *   const cms = useCms()
 *   const title = cms.text('homepage', 'hero_title') // Get text from CMS
 *   const phone = cms.contact.phone // Get entire group
 */
export function useCms() {
  const store = useSettingsStore()

  // Text helper - get text from CMS with fallback
  const text = (group, key, fallback = '') => {
    return store.getSetting(group, key, fallback)
  }

  // Get entire group
  const group = (groupName) => {
    return store.getGroup(groupName)
  }

  // Quick access to common groups
  const general = computed(() => store.generalSettings)
  const contact = computed(() => store.contactSettings)
  const social = computed(() => store.socialSettings)
  const seo = computed(() => store.seoSettings)
  const footer = computed(() => store.footerSettings)
  const header = computed(() => store.headerSettings)

  // Page-specific content
  const contactPage = computed(() => store.contactPageSettings)
  const serviceCenterPage = computed(() => store.serviceCenterPageSettings)
  const distributorsPage = computed(() => store.distributorsPageSettings)
  const supportPage = computed(() => store.supportPageSettings)

  return {
    text,
    group,
    general,
    contact,
    social,
    seo,
    footer,
    header,
    contactPage,
    serviceCenterPage,
    distributorsPage,
    supportPage,
    store,
  }
}
